import "babel-polyfill" // promise fix for ie
import React from "react"
import { render } from "react-dom"
import App from "./components/app/app-component"

window.React = React;

if( window.location.pathname.substring( window.location.pathname.length - 1) !== "/")
{
    console.log("URL requires an ending slashes. Redirecting to correct URL.");
    window.location.replace(window.location.pathname + "/");
}


render(
    <App />,
    document.getElementById("root")
)



// WEBPACK FOOTER //
// ./src/index.js